import { useEffect, useState } from 'react'
import ProfileBase from '../../../components/Profile/ProfileBase'
import style from './ChangeLanguage.module.css'
import { authFetch } from '../../../common/utils/cognito'
import { useNavigate } from 'react-router-dom'
import { useUserStore } from '../../../store/user-store'
import { t } from 'i18next'
import { useFeedStore } from '../../../store/feed-store'
import { SupportedLanguages } from '../../../common/types/translatable'

const languagesList: Array<{
  label: string
  value: SupportedLanguages
}> = [
  {
    label: 'Deutsch',
    value: 'de',
  },
  {
    label: 'English',
    value: 'en',
  },
]

const ChangeLanguage = () => {
  const navigate = useNavigate()
  const { currentUser, fetchUser } = useUserStore()
  const { resetFeed } = useFeedStore()
  const [selectedLanguage, setSelectedLanguage] = useState<SupportedLanguages>(
    currentUser?.language || 'de',
  )

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  useEffect(() => {
    setSelectedLanguage(currentUser?.language || 'de')
  }, [currentUser, setSelectedLanguage])

  const handleSaveClick = async () => {
    const response = await authFetch(`${process.env.REACT_APP_API_URL}/me`, {
      method: 'PATCH',
      body: JSON.stringify({
        language: selectedLanguage,
      }),
    })

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    await fetchUser()
    resetFeed()

    navigate('/profile')
  }

  const getLanguageStyle = (language: string) => {
    if (language === selectedLanguage) {
      return style.selectedLanguage
    }
  }

  return (
    <ProfileBase
      backButtonAction={() => navigate('/profile')}
      title={t('profile.changeLanguage')}
      buttonTitle={t('profile.save')}
      onButtonClick={handleSaveClick}
    >
      <div className={style.languageContainer}>
        {languagesList.map(({ label, value }) => (
          <div
            onClick={() => setSelectedLanguage(value)}
            className={`${style.languageItem} ${getLanguageStyle(value)}`}
            key={value}
          >
            {label}
          </div>
        ))}
      </div>
    </ProfileBase>
  )
}

export default ChangeLanguage
